module.exports = __webpack_public_path__ + "images/avatars/female/11.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/11.svg
// module id = Zkh2
// module chunks = 118